import React, { useState } from "react";
import { Tooltip, message } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";

type Props = {
  text: string;
  label?: string;
};

const CopyIconAntStyle: React.FC<Props> = ({ text, label = "dữ liệu" }) => {
  const [copied, setCopied] = useState(false);

  const onCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      message.success(`Đã copy ${label}`);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      message.error("Copy thất bại");
    }
  };

  return (
    <Tooltip title={copied ? "Copied" : "Copy"}>
      <span
        onClick={onCopy}
        style={{
          color: copied ? "#52c41a" : "#1677ff", // xanh Antd
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          transition: "all 0.2s ease",
        }}
      >
        {copied ? <CheckOutlined /> : <CopyOutlined />}
      </span>
    </Tooltip>
  );
};

export default CopyIconAntStyle;
